export const experiences = [
  
  {
    id: 1,
    position: "Backend Developer Intern",
    company: "Gamage Recruiters",
    date: "2026 Feb 02 - 2026 Aug 03",
    duration: "6 months",
    description: "Contributed to the development of backend services using Spring Boot and Java. Designed and implemented REST APIs, worked with relational databases, tested application functionality, resolved issues, and collaborated with the development team to deliver scalable and maintainable solutions.",
    skills: ["Spring Boot", "Java"]
  },
  /*
  {
    id: 2,
    position: "Junior Web Developer",
    company: "Digital Agency",
    date: "2019 - 2021",
    description: "Built client websites using HTML, CSS, and JavaScript. Assisted in the development of WordPress themes and plugins.",
    skills: ["HTML", "CSS", "JavaScript", "WordPress"]
  },
  {
    id: 3,
    position: "Web Development Intern",
    company: "StartUp Co.",
    date: "2018 - 2019",
    description: "Learned web development fundamentals and contributed to small projects. Assisted in debugging and testing web applications.",
    skills: ["HTML", "CSS", "JavaScript"]
  }*/
];